export default "__VITE_ASSET__DVoV4lyb__"